import { Button, Content } from 'rsuite';
import styles from './ResultsButton.module.scss';

interface ResultsButtonProps {
  onClick: () => void;
  hasDataRendered: boolean;
}

export const ResultsButton = ({ onClick, hasDataRendered }: ResultsButtonProps) => (
  <Content className={styles['result-button-content']}>
    <Button id="competitivite-results-button" appearance="primary" className={styles['result-button']} onClick={onClick}>
      {hasDataRendered ? 'ATUALIZAR RESULTADOS' : 'VISUALIZAR RESULTADOS'}
    </Button>
  </Content>
);
